import { IntegrationSelectCompanyWebView } from '../view/IntegrationSelectCompanyWebView';
import { templateIntegrationSelectCompany } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { IntegrationSelectCompanyWebComponent } from '../component/IntegrationSelectCompanyWebComponent';
import { CreateIntegrationEvent } from '../../addIntegrationPanel/types/CreateIntegrationEvent';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class IntegrationSelectCompanyWebController extends BaseWebComponentController {
  public component: IntegrationSelectCompanyWebComponent;
  public view: IntegrationSelectCompanyWebView;
  public viewConstructor: typeof IntegrationSelectCompanyWebView;

  constructor(component: IntegrationSelectCompanyWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrationSelectCompanyWebView,
      viewTemplate: templateIntegrationSelectCompany,
    });
  }

  public async getDataForView(): Promise<any> {
    return this.dependencies.api.clients.Company.getAvailableCompanies({}, getRequestDefaultOptions());
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.component,
        event: CreateIntegrationEvent.CreateCompanySelector,
        callback: this.buildCompanySelectorDropdown,
      },
    ];
  }

  private async buildCompanySelectorDropdown(): Promise<any> {
    const response = await this.getDataForView();
    this.view.dom.$companySelector.propertiesSet = false;
    this.view.dom.$companySelector.availableCompanies = response;
    this.view.dom.$companySelector.onCompanyClicked = this.onCompanyClicked.bind(this);
    this.view.dom.$companySelector.injectDependencies(this.dependencies);
    await this.view.dom.$companySelector.selectActiveCompany();
    this.view.dom.$companySelector.propertiesSet = true;
    this.view.dom.$companySelector.start().catch(console.error);
  }

  private async onCompanyClicked(clickedCompany: Target): Promise<any> {
    this.dependencies.setActiveCompany(clickedCompany.companyId, clickedCompany.companyName);
    this.view.dom.$integrationSelectCompanyWrapper.dispatchEvent(
      new CustomEvent(CreateIntegrationEvent.OnCompanySelect, {
        bubbles: true,
        composed: true,
      })
    );
  }
}
